export const getRemoveOnClickFunc =
  (mappingFieldsArrState, controlButtonStringIdState) => (e) => {
    const [, setMappingFieldsArrStateValue] = mappingFieldsArrState;

    setMappingFieldsArrStateValue((prevValue) => {
      return [...prevValue.slice(0, -1)];
    });

    const [, setControlButtonStringIdStateValue] = controlButtonStringIdState;
    setControlButtonStringIdStateValue("add");
  };
